// extracted by mini-css-extract-plugin
export default {"root":"MaskInput_root__4KLI5"};